module.exports = __webpack_public_path__ + "static/media/newspaper-news-svgrepo-com.646cf71d.svg";